import { tv } from 'tailwind-variants';

export const alertStyle = tv({
  slots: {
    base: 'inline-flex w-full items-center rounded-lg p-3',
    text: 'ml-3 grow text-sm font-light',
    icon: 'size-5 shrink-0'
  },
  variants: {
    type: {
      success: 'bg-success/10 text-success',
      info: 'bg-info/10 text-info',
      error: 'bg-error/10 text-error',
      warning: 'bg-warning/10 text-warning',
      neutral: 'bg-secondary/10 text-secondary'
    },
    dense: {
      true: {
        text: 'text-xs'
      }
    },
    clickable: {
      true: 'cursor-pointer'
    }
  }
});
